import {Link} from 'react-router-dom';

function Navp({Click,Close}) {
    return (
        <>
            <nav class={Click ? 'Navp' : 'Navpf'}>
            <Link to="/" class="NavItem">Home</Link>
            <Link to="/tutors-list-page" class="NavItem">Tutors</Link>
            <Link class="NavItem">Join us</Link>
            <Link class="NavItem">About</Link>
            <Link class="NavItem">Contact</Link>
            </nav>
            <div class={Click ? 'Navp-background' : ''} onClick={Close}/>
            </>
        )
}

export default Navp